import { Link } from "react-router-dom";
import { Calendar, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ThemeToggle";

export const PublicLayout = ({ children, showBack = false, backTo = "/" }) => {
  return (
    <div className="min-h-screen bg-background hero-pattern relative">
      {/* Header */}
      <header className="sticky top-0 z-30 bg-background/80 backdrop-blur-xl border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-4">
              {showBack && (
                <Link to={backTo}>
                  <Button variant="ghost" size="icon" className="rounded-full" data-testid="back-button">
                    <ArrowLeft className="w-5 h-5" />
                  </Button>
                </Link>
              )}
              <Link to="/" className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center">
                  <Calendar className="w-5 h-5 text-primary-foreground" />
                </div>
                <span className="font-nunito font-bold text-xl hidden sm:block">Javis Academy</span>
              </Link>
            </div>
            <div className="flex items-center gap-3">
              <ThemeToggle />
              <Link to="/login">
                <Button variant="outline" size="sm" className="rounded-full" data-testid="admin-login-link">
                  Área Admin
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="relative">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-border py-8 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm text-muted-foreground">
            Javis Academy - Sistema de Agendamento de Workshops
          </p>
        </div>
      </footer>
    </div>
  );
};
